import { build, buildSearch, hashBuild, hashQuery, parseURL, query } from '@didi/webx-js-core';
function getURL(url) {
    if (url) {
        return url;
    }
    return window.location.href;
}
function parseURLWeb(url) {
    return parseURL(getURL(url));
}
function queryWeb(url) {
    return query(getURL(url));
}
function hashQueryWeb(url) {
    return hashQuery(getURL(url));
}
export { getURL, build, buildSearch, hashBuild, hashQueryWeb as hashQuery, parseURLWeb as parseURL, queryWeb as query };
